module.exports = __webpack_public_path__ + "static/media/ic_popup_kyc_verified.16c06a49.svg";